import { GetTenantModel } from "@factory/model/query-model-tenant";
import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";

import { tenantFormDefault } from "./form.default";
import { TenantFormSchema } from "./form.rule";

export const useFormDefaultTenant = () => {
  const { formatDate } = useDateTimeContext();

  const getDefault = (cachedValue: GetTenantModel | undefined) => {
    return !cachedValue
      ? tenantFormDefault
      : ({
          owner: cachedValue.owner,
          businessName: cachedValue.business_name,
          businessType: cachedValue.business_type,
          description: cachedValue.description,
          avatar: cachedValue.avatar,
          email: cachedValue.email,
          mobileNumber: cachedValue.mobile_number,
          phoneNumber: cachedValue.phone_number,
          website: cachedValue.website,
          membershipDate: formatDate(cachedValue.membership_date) as any,
          rewardsType: cachedValue.rewards_type,
          postRegistrationLink: cachedValue.post_registration_link,
          postRegistrationMessage: cachedValue.post_registration_message,
        } as TenantFormSchema);
  };

  return {
    getDefault,
  };
};
